// extracted by mini-css-extract-plugin
module.exports = {"root":"TableView_root__3VCq1"};